import { useContext, useEffect, useState, useCallback } from "react";

import { UserContext } from "../../../context/User.context";

import {
  Button,
  Popconfirm,
  QRCode,
  Modal,
  Space,
  Table,
  Tag,
  Input,
  Select,
  Form,
  notification,
  DatePicker,
  Pagination,
} from "antd";
import {
  DeleteOutlined,
  FileDoneOutlined,
  HomeFilled,
  InfoCircleTwoTone,
  InfoCircleFilled,
  DownloadOutlined,
  DeliveredProcedureOutlined,
  UserAddOutlined,
  PictureOutlined,
} from "@ant-design/icons";

import { useNavigate } from "react-router-dom";
import {
  formatDate,
  formatTimeDate,
  isDatePassed,
} from "../../../utils/DateTime";
import { debounce } from "lodash"; // Menggunakan lodash untuk debounce
import { useHttp } from "../../../utils/DataHendler";
import axios from "axios";
import FileSaver from "file-saver";
import { useMediaQuery } from "react-responsive";

export const EventTable = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 768 }); //
  const { getData, patchData } = useHttp();
  const { user } = useContext(UserContext);
  const { error, warning } = Modal;
  const { Search } = Input;
  const [form] = Form.useForm();

  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletedId, setDeletedId] = useState(0);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [filters, setFilters] = useState({}); // State untuk menyimpan filter saat ini

  // LOADING STATE
  const [api, contextHolder] = notification.useNotification();
  const [data, setData] = useState([]);

  useEffect(() => {
    // getVisitor();
    fetchData();
  }, [user]);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  // Fungsi untuk mengambil data dari API
  const fetchData = async (queryParams) => {
    setLoading(true);
    try {
      const response = await getData(`/event`, { params: queryParams }, false);
      // const result = await response.json();
      // console.log("DISINI");

      if (response.success) {
        console.log(response.data.data);

        const structuredData = response.data.data.map(
          ({ id, code, title, description, created_at, updated_at }) => ({
            key: id,
            id,
            code,
            title,
            description,
            created_at,
            updated_at,
          })
        );
        setData(structuredData);

        console.log(structuredData);
        setPagination({
          page: response.data.pagination.page,
          limit: response.data.pagination.limit,
          total: response.data.pagination.total,
          totalPages: response.data.pagination.totalPages,
        });
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handler untuk perubahan halaman
  const handlePageChange = (newPage) => {
    // fetchData( newPage, pagination.limit);
    handleFilterChange({ page: newPage || 1, limit: pagination.limit });
  };

  // Versi debounce dari getVisitor
  const debouncedGetVisitor = useCallback(
    debounce((newFilters) => {
      // getVisitor(newFilters); // Panggil getVisitor setelah debounce
      fetchData(newFilters);
    }, 900), // Delay 500ms
    []
  );
  // Handler untuk memperbarui filter dan panggil debouncedGetVisitor
  const handleFilterChange = (newFilter) => {
    const updatedFilters = { ...filters, ...newFilter };

    // Hapus filter yang di-set null atau kosong
    Object.keys(updatedFilters).forEach((key) => {
      if (updatedFilters[key] === null || updatedFilters[key] === "") {
        delete updatedFilters[key];
      }
    });

    setFilters(updatedFilters); // Perbarui state filters
    debouncedGetVisitor(updatedFilters); // Panggil versi debounce dari getVisitor
  };

  const deleteHendler = async (ids) => {
    try {
      await patchData(`/event/${ids}`, {}, {}, true);
      setDeletedId(0);

      // getVisitor();
      await fetchData();
      // message.success(res.data.message);
      api["success"]({
        message: "Delete Successfully ",
        description: "delete success",
      });
    } catch (error) {
      console.log(error);
    }
  };

  // // Fungsi untuk mengunduh file Excel
  // const downloadExcel = async () => {
  //   setLoading(true);
  //   try {
  //     // Kirim permintaan ke backend untuk mendapatkan file Excel
  //     const response = await axios.post(
  //       "https://umkm-bojonggede-be.vercel.app/visitor/export", // Ganti dengan URL backend Anda
  //       {},
  //       {
  //         responseType: "blob", // Pastikan respons diolah sebagai blob
  //         params: filters,
  //       }
  //     );

  //     // Simpan file menggunakan FileSaver.js
  //     FileSaver.saveAs(new Blob([response.data]), "datavisitor.xlsx");

  //     // Tampilkan notifikasi sukses
  //     api["success"]({
  //       message: "File Excel berhasil diunduh",
  //       description: "File Excel berhasil diunduh",
  //     });
  //   } catch (error) {
  //     console.error("Error downloading Excel:", error);

  //     // Tampilkan notifikasi error
  //     api["error"]({
  //       message: "Gagal mengunduh file Excel.",
  //       description: "Silakan coba lagi atau hubungi administrator.",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const columns = [
    {
      title: "Name",
      dataIndex: "title",
      key: "title",
    },

    {
      title: "Kode",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Deskripsi",
      dataIndex: "description",
      key: "description",
    },

    {
      title: "Action",
      key: "action",
      fixed: "right",
      render: (_, record) => (
        <Space size="middle">
          <Button
            icon={<InfoCircleFilled />}
            onClick={() => {
              navigate(`/user/detail-event/${record.id}`);
            }}
          />

          <Button
            icon={<DeleteOutlined color="#EA5B6F" />}
            onClick={() => {
              deleteHendler(record.id);
            }}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      {contextHolder}
      <div
        style={{
          marginBottom: "15px",
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
          justifyContent: isMobile ? "flex-start" : "space-between", // Sesuaikan alignment
          alignItems: isMobile ? "flex-start" : "center", // Sesuaikan alignment
          gap: isMobile ? "10px" : "0px", // Tambahkan jarak antar elemen jika mobile
        }}
      >
        {/* Bagian Filter */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
            gap: isMobile ? "10px" : "5px", // Tambahkan jarak antar elemen jika mobile
            width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
          }}
        >
          {/* Search Filter */}
          <Search
            style={{
              marginRight: isMobile ? "0px" : "5px", // Hapus margin kanan jika mobile
              width: isMobile ? "100%" : "200px", // Lebar penuh jika mobile
            }}
            placeholder="search name or code"
            allowClear
            onChange={(e) => {
              const value = e.target.value.trim();
              handleFilterChange({ search: value || null });
            }}
            onSearch={(value) => {
              handleFilterChange({ search: value.trim() || null });
            }}
            enterButton
          />
        </div>

        {/* Tombol Export */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // Ubah menjadi kolom jika mobile
            gap: isMobile ? "10px" : "5px", // Tambahkan jarak antar elemen jika mobile
            width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
          }}
        >
          <Button
            style={{
              marginTop: isMobile ? "10px" : "0px", // Tambahkan margin atas jika mobile
              backgroundColor: "#41B3A2",
              color: "white",
              borderColor: "#41B3A2",
              width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
            }}
            icon={<PictureOutlined />}
            onClick={() => {
              navigate(`/user/addevent`);
            }}
            loading={loading}
          >
            Add Event
          </Button>
          {/* <Button
            style={{
              marginTop: isMobile ? "10px" : "0px", // Tambahkan margin atas jika mobile
              backgroundColor: "#41B3A2",
              color: "white",
              borderColor: "#41B3A2",
              width: isMobile ? "100%" : "auto", // Lebar penuh jika mobile
            }}
            icon={<DeliveredProcedureOutlined />}
            onClick={() => {
              navigate(`/user/addumkm`);
            }}
            loading={loading}
          >
            Export
          </Button> */}

          {/*
          <Button
            style={{
              marginTop: isMobile ? "0px" : "0px",
              marginLeft: isMobile ? "0px" : "10px",
              backgroundColor: "#088395",
              color: "white",
              borderColor: "#088395",
              width: isMobile ? "100%" : "auto",
            }}
            icon={<DeliveredProcedureOutlined />}
            onClick={downloadExcel}
            loading={loading}
          >
            Add Visitor
          </Button> */}
        </div>
      </div>
      <Table
        dataSource={data}
        columns={columns}
        loading={loading}
        scroll={{
          x: "max-content", // Aktifkan scroll horizontal dengan lebar otomatis
          y: 550,
        }}
        // rowKey={(record) => record.id}
        pagination={false} // Matikan pagination bawaan Ant Design
        // expandable={{
        //   expandedRowRender: (record) => (
        //     <Space direction="vertical" size="middle">
        //       <Space size="middle">
        //         {
        //           <>
        //             <div style={{ display: "flex" }}>
        //               {/* <Barcode value={record.code} /> */}
        //               <div
        //                 style={{
        //                   display: "flex", // Menggunakan flexbox untuk mengatur layout
        //                   flexDirection: "column", // Menyusun elemen secara vertikal
        //                   alignItems: "center", // Menyusun elemen anak ke tengah secara horizontal
        //                   justifyContent: "center", // Menyusun elemen anak ke tengah secara vertikal
        //                   margin: "auto", // Memastikan div ini berada di tengah parent-nya
        //                   border: "2px solid rgb(0, 0, 0)", // Border dengan warna biru
        //                   borderRadius: "10px", // Radius border untuk tampilan lebih modern
        //                   padding: "5px", // Memberikan ruang di dalam border
        //                   width: "fit-content", // Lebar div menyesuaikan konten
        //                 }}
        //               >
        //                 <QRCode
        //                   id="myqrcode" // ID untuk referensi elemen QR Code
        //                   size={130} // Ukuran QR Code
        //                   errorLevel="H" // Tingkat kesalahan tinggi untuk QR Code
        //                   value={`${record?.code}`} // Nilai yang akan di-encode ke dalam QR Code
        //                   bgColor="#fff" // Warna latar belakang QR Code
        //                   type="canvas" // Pastikan tipe adalah "canvas"
        //                 />
        //                 <p
        //                   style={{
        //                     textAlign: "center", // Membuat teks berada di tengah
        //                     fontSize: "14px", // Ukuran font
        //                     fontWeight: "bold", // Membuat teks lebih tebal
        //                   }}
        //                 >
        //                   {record?.code}
        //                 </p>
        //               </div>

        //               <div style={{ display: "block" }}>
        //                 <Space
        //                   direction="vertical"
        //                   style={{ padding: "0 0 0 15px" }}
        //                 >
        //                   <div
        //                     style={{
        //                       fontWeight: "bold",
        //                       borderBottom: "2px solid #088395",
        //                       paddingBottom: "5px",
        //                       width: "fit-content",
        //                     }}
        //                   >
        //                     Approve At
        //                   </div>
        //                   <p
        //                     style={{
        //                       margin: 0,
        //                     }}
        //                   >
        //                     {record.expandableData.approve_at
        //                       ? formatTimeDate(record.expandableData.approve_at)
        //                       : "-"}
        //                   </p>
        //                   <div
        //                     style={{
        //                       fontWeight: "bold",
        //                       borderBottom: "2px solid #088395",
        //                       paddingBottom: "5px",
        //                       width: "fit-content",
        //                     }}
        //                   >
        //                     Approved By
        //                   </div>
        //                   <p
        //                     style={{
        //                       margin: 0,
        //                     }}
        //                   >
        //                     {record.expandableData.approver?.username ??
        //                       "belum diapprove"}
        //                   </p>
        //                 </Space>
        //                 {/* <Space
        //                   direction="vertical"
        //                   style={{ padding: "0 0 0 15px" }}
        //                 >
        //                   <div
        //                     style={{
        //                       fontWeight: "bold",
        //                       borderBottom: "2px solid #088395",
        //                       paddingBottom: "5px",
        //                       width: "fit-content",
        //                     }}
        //                   >
        //                     DiApprove Oleh
        //                   </div>
        //                   <p
        //                     style={{
        //                       margin: 0,
        //                     }}
        //                   >
        //                     {record.expandableData.approver?.username ??
        //                       "belum diapprove"}
        //                   </p>
        //                 </Space> */}
        //               </div>

        //               <Space
        //                 direction="vertical"
        //                 style={{ padding: "0 0 0 15px" }}
        //               >
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Expired At
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.expired_at == null
        //                     ? "please verified to start access"
        //                     : formatDate(record.expandableData.expired_at)}
        //                 </p>
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Verified By
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.verificator?.username ??
        //                     "belum diverifikasi"}
        //                 </p>
        //               </Space>
        //               <Space
        //                 direction="vertical"
        //                 style={{ padding: "0 0 0 15px" }}
        //               >
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Department
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.department_name}
        //                 </p>
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   Appointment
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   {record.expandableData.appointment ?? "-"}
        //                 </p>
        //               </Space>
        //               <Space
        //                 direction="vertical"
        //                 style={{ padding: "0 0 0 15px" }}
        //               >
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   IN TIME
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   <Tag
        //                     // key={visitor.id}
        //                     color={"green"} // Warna sesuai status is_take
        //                     style={{
        //                       fontWeight: "bold",
        //                     }}
        //                   >
        //                     {record.expandableData.in_at
        //                       ? formatTimeDate(record.expandableData.in_at)
        //                       : "-"}
        //                   </Tag>
        //                 </p>
        //                 <div
        //                   style={{
        //                     fontWeight: "bold",
        //                     borderBottom: "2px solid #088395",
        //                     paddingBottom: "5px",
        //                     width: "fit-content",
        //                   }}
        //                 >
        //                   OUT TIME
        //                 </div>
        //                 <p
        //                   style={{
        //                     margin: 0,
        //                   }}
        //                 >
        //                   <Tag
        //                     // key={visitor.id}
        //                     color={"red"} // Warna sesuai status is_take
        //                     style={{
        //                       fontWeight: "bold",
        //                     }}
        //                   >
        //                     {record.expandableData.out_at
        //                       ? formatTimeDate(record.expandableData.out_at)
        //                       : "-"}
        //                   </Tag>
        //                 </p>
        //               </Space>
        //             </div>
        //           </>
        //         }
        //       </Space>

        //       <Space direction="vertical" style={{ padding: "0 0 0 15px" }}>
        //         {/* TEMPAT KARTU */}
        //         {record.expandableData.card_visitors.length <= 0 ? (
        //           <span
        //             style={{
        //               color: "red",
        //               fontSize: "12px",
        //               // fontWeight: "normal",
        //               animation: "blink 1s infinite",
        //             }}
        //           >
        //             Don't Have a Visitor Card
        //           </span>
        //         ) : (
        //           <div>
        //             <div
        //               style={{
        //                 fontWeight: "bold",
        //                 borderBottom: "2px solid #088395",
        //                 paddingBottom: "5px",
        //                 width: "fit-content",
        //               }}
        //             >
        //               Card Used
        //             </div>

        //             <div
        //               style={{
        //                 display: "flex",
        //                 flexWrap: "wrap", // Memungkinkan elemen pindah ke baris baru jika tidak cukup ruang
        //                 gap: "10px", // Menambahkan jarak antara Tag
        //                 marginTop: "5px",
        //               }}
        //             >
        //               {record.expandableData.card_visitors.map((el) => (
        //                 <Tag
        //                   key={el.card_code} // Tambahkan key untuk setiap Tag agar lebih optimal
        //                   color={el.returned_at ? "red" : "green"} // Warna sesuai status is_take
        //                   style={{
        //                     fontWeight: "bold",
        //                     padding: "5px 10px", // Padding untuk membuat Tag lebih besar dan mudah dibaca
        //                   }}
        //                 >
        //                   {`${el.card_code}`}
        //                   {el.returned_at != null ? ` | ` : ""}
        //                   <i>
        //                     {el.returned_at != null
        //                       ? ` ${formatTimeDate(el.returned_at)}`
        //                       : ""}
        //                   </i>
        //                 </Tag>
        //               ))}
        //             </div>
        //           </div>
        //         )}
        //       </Space>
        //     </Space>
        //   ),
        // }}
      />
      {/* Pagination Controls */}
      <Pagination
        current={pagination.page}
        pageSize={pagination.limit}
        total={pagination.total}
        onChange={handlePageChange}
        showSizeChanger={false}
        style={{ marginTop: 20, textAlign: "center" }}
      />
    </>
  );
};
